import initialState from './initialState';
import { reducer as saveCrashReportReducer } from './saveCrashReport';
import { reducer as loadProjectVersionReducer } from './loadProjectVersion';

const reducers = [saveCrashReportReducer, loadProjectVersionReducer];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
